export default __webpack_public_path__ + "static/media/17.dd4edab0.png";